<template>
  <modal v-if="isShown" :errors="errors">
    <div slot="header">
      <h4 class="modal-title">Créer un client</h4>
      <a @click.prevent="$parent.toggleModal()" href="#" class="btn pull-right closeWindow">
        <i class="fas fa-times fa-2x"></i>
      </a>
    </div>
    <div slot="body">
      <customer-form :selectedCustomer="customer" :hasBilling="hasBilling"></customer-form>
    </div>
    <div slot="footer">
      <button class="btn btn-block green" :disabled="submitting" @click.prevent="createCustomer">Créer</button>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'customerModal',
  props:{
    show: {
      type: Boolean,
      default: false
    },
    hasBilling:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customer:{},
      isShown: this.show,
      errors: {},
      submitting:false
    }
  },
  mounted () {
    Event.listen('errors', (e) => {
        this.errors = e
    })
  },
  watch: {
    show: function(newVal, oldVal) {
      this.isShown = newVal
    }
  },
  methods: {
    createCustomer() {//save customer
      this.submitting=true;
      this.customer.type = this.customerType
      if(this.customerType=="struct"){
        this.customer.name=""
      }
      axios.post('/customer', this.customer)
        .then((res) => {
          this.$emit('input', res.data.customer)
          this.$snotify.success('Client enregistré avec succès !')
          this.$parent.toggleModal()
          this.customer={}
        })
        .catch((error)=>{
          console.log(error)
        })
        .then(()=>{//always executed
          this.submitting=false;
        })
    },
  },
  computed: {
      customerType : function () {
        return this.customer.name?  "individual" : "structure"
    },
  }
};
</script>